<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        <span>{{ 'quoteTracking.emptyCart' | cxTranslate }}</span>
      </div>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row">
        <div class="col-sm-6 col-md-6 reject-btn">
          <button
            cxAutoFocus
            class="vs-primary-btn"
            (click)="closeModal('quote-edit')"
          >
            {{ 'quoteTracking.confirm' | cxTranslate }}
          </button>
        </div>
        <div class="col-sm-6 col-md-6">
          <button
            cxAutoFocus
            class="vs-tertiary-btn"
            (click)="closeModal('close')"
          >
            {{ 'quoteTracking.cancel' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
